import React from 'react';
import { List, Icon, AutoComplete, Input, notification, Spin } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import * as actions from '../../../actions/subscriptionAction';
import { Link } from 'react-router-dom';
import { withRouter } from "react-router-dom";
import { Strings } from "../../../dataProvider/localize";
import { abbrivationStr, currencyFormat } from '../../../utils/common';
import ScrollArea from 'react-scrollbar';


class SubscriptionSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      seacrhValue: '',
      viewButton: true,
      activeId: null,
      allLoaded: false
    }
  }

  componentDidMount() {
    this.setState({ viewButton: true });
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (!props.location.pathname.includes("showSubscription"))
      this.setState({ activeId: null });
  }

  handleOrganizationClick = (organId) => {
    this.setState({ activeId: organId });
  }

  handelSearchChange = searchValue => {
    this.setState({
      ...this.state,
      searchValue: searchValue,
    });
    if (searchValue.length >= 3) {
      this.props.action.searchExpandSubscriptionsList(searchValue, 1, true)
        .then(listLength => {
          if (listLength < 10) {
            this.setState({ viewButton: false })
          } else {
            this.setState({ viewButton: true, allLoaded: false })
          }
        })
        .catch((message) => {
          notification.error({
            message: Strings.error_title,
            description: message ? message : Strings.generic_error,
            onClick: () => { },
            className: 'ant-error'
          });
        });
    } else if (searchValue.length === 0) {
      this.props.action.initSubscriptions()
        .then((flag) => {
          this.setState({ viewButton: true, allLoaded: false })
        })
        .catch((message) => {
          notification.error({
            message: Strings.error_title,
            description: message ? message : Strings.generic_error,
            onClick: () => { },
            className: 'ant-error'
          });
        });
    }
  };

  handelViewAllClick = () => {
    this.props.action.searchExpandSubscriptionsList(this.state.searchValue, this.props.pageNumber + 1, false)
      .then((listLength) => {
        this.setState({ viewButton: false }, () => {
          if (listLength < 10) {
            this.setState({ allLoaded: true })
          }
        });
      })
      .catch((message) => {
        notification.error({
          message: Strings.error_title,
          description: message ? message : Strings.generic_error,
          onClick: () => { },
          className: 'ant-error'
        });
      });
  };

  handleScroll = (value) => {
    if (!this.state.allLoaded && value.topPosition && ((value.containerHeight + value.topPosition) >= value.realHeight)) {
      this.props.action.searchExpandSubscriptionsList(this.state.searchValue, this.props.pageNumber + 1, false, true)
        .then((listLength) => {
          if (listLength < 10)
            this.setState({ allLoaded: true })
        })
        .catch((message) => {
          notification.error({
            message: Strings.error_title,
            description: message ? message : Strings.generic_error,
            onClick: () => { },
            className: 'ant-error'
          });
        });
    }
  }

  render() {

    // const dataSource = this.props.subscriptions.filter(subscript => subscript.name.toLowerCase().includes(this.state.seacrhValue.toLowerCase()));

    const dataSource = this.props.subscriptions && this.props.subscriptions.length > 0 ? this.props.subscriptions : []

    return (
      <div className={this.props.togleSearch ? "col-md-3 mb-4 sf-searchbar" : "col-md-3 mb-4 closed sf-searchbar"}>
        <button onClick={this.props.handleSearchToggle} className="bnt-searchbar open"><Icon type="left" /></button>
        <div className="sf-card">
          <div className="sf-card-head">
            {/* search text box  */}
            <div className="auto-search-txt search-lists">
              <AutoComplete
                className="certain-category-search"
                dropdownClassName="certain-category-search-dropdown"
                dropdownMatchSelectWidth={false}
                dropdownStyle={{ width: 300 }}
                size="large"
                style={{ width: '100%' }}
                onChange={this.handelSearchChange}
                placeholder={Strings.search_placeholder}
                optionLabelProp="value"
              >
                <Input className={this.props.showMiniSpinner ? "list-search-spin" : ""} suffix={
                  !this.props.showMiniSpinner
                    ? <Icon type="search" />
                    : <Spin indicator={<Icon type="loading" spin />} />
                } />
              </AutoComplete>
            </div>
            {/* search text box  */}
          </div>
          <div className={this.state.viewButton && this.props.subscriptions.length >= 10 ? "sf-search-body" : "sf-search-body add-height"}>
            {
              this.props.showScrollSpinner
                ? <div className="search-list-spin"><Spin indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />} /></div>
                : null
            }
            <div className={this.state.viewButton ? "sf-card-body p-0" : "sf-card-body p-0 search-lists-bar"}>
              <ScrollArea speed={0.8} smoothScrolling={true}
                className="sf-scroll" onScroll={(value) => { this.handleScroll(value) }} horizontal={false}>
                <List className="sf-service-list"
                  itemLayout="horizontal"
                  dataSource={this.state.viewButton ? dataSource.slice(0, 10) : dataSource}
                  renderItem={item => (
                    <List.Item className={this.state.activeId !== null ?
                      this.state.activeId === item.subscription_id ? "active" : "disable-lists" : ""} onClick={() => this.handleOrganizationClick(item.subscription_id)} >
                      <Link to={{ pathname: this.props.match.path + '/showSubscription', state: item.subscription_id }}>
                        <List.Item.Meta
                          avatar={<label>{abbrivationStr(item.name)}</label>}
                          title={item.name}
                          description={<div className="itm-amount-date">
                            <span>{currencyFormat(item.amount)}</span>
                            {/* <span>{item.period}</span> */}
                            <span>{item.period ? item.period === 1 ? "Monthly" : item.period === 3 ? "Quarterly" : item.period === 12 ? "Yearly" : '' : ''}</span>
                          </div>}
                        />
                      </Link>
                    </List.Item>

                  )}
                />
              </ScrollArea>
            </div>
            {
              this.state.viewButton && this.props.subscriptions.length >= 10
                ? <div className="sf-card-footer d-flex align-items-end justify-content-center">
                  <button className="v-all-org" onClick={this.handelViewAllClick}>{Strings.sub_view_all_btn}</button>
                </div>
                : null
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    subscriptions: state.subscription.subscriptions,
    pageNumber: state.subscription.currentPageNumber,
    showMiniSpinner: state.auth.showMiniSpinner,
    showScrollSpinner: state.auth.showScrollSpinner
  }
}

const mapDispatchToprops = dispatch => {
  return {
    action: bindActionCreators(actions, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToprops)(SubscriptionSearch))
